import React, { useEffect } from 'react';
//componets
import FlNav from './landingComponents/Navbar';
import FlFooter from './landingComponents/Footer';

import icn_vision from '../../assets/img/landingPage/about/aboutUs_vision.svg';

//key features
import key01 from '../../assets/img/landingPage/financial/financial_financial_03.png';
import key02 from '../../assets/img/landingPage/insurance/insurance_02.png';
import key03 from '../../assets/img/landingPage/insurance/insurance_03.png';
import key04 from '../../assets/img/landingPage/connectors/Connectors_03.png';
import key05 from '../../assets/img/landingPage/insurance/insurance_05.png';

import fondo from '../../assets/img/landingPage/fondo.png';
import ReactGA from 'react-ga4'

import Favicon from '../../assets/img/Favicon_AVAP_Framework.png'

//Importaciones de otros archivos, revisar y borrar
import gradientApi from '../../assets/img/landingPage/gradientApi.png'
import gradientServices from '../../assets/img/landingPage/gradientServices.png'

import product_gateway from '../../assets/img/landingPage/Gateway.png'
import dashboard from '../../assets/img/landingPage/cloud/Cloud-home.png';


const Insurance = () => {


    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-08SZKPG9V0');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: '101OBEX, CORP About Page' });
            }

    }, [])


    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-08SZKPG9V0');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: '101OBEX, CORP About Page' });
            }

    }, [])

    useEffect(() => {
        // favicon 
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = Favicon; // Usa la ruta importada directamente
        document.head.appendChild(link);
    
        // clean favicon 
        return () => {
          document.head.removeChild(link);
        };
      }, []);

    useEffect(() => {

        document.body.classList.add('dark-bg');
        return () => {
            document.body.classList.remove('dark-bg');
        };

    }, []);

    const productDetailsA = {
        Key_Feature_01: {
            title: 'Connect and engage customers seamlessly',
            text: "Bring together policyholder data, financial details, and interactions in one view. Empower agents and service teams with the full story to deliver fast, personalized support.",
            altDescription: "Bring together policyholder data, financial details, and interactions in one view. Empower agents and service teams with the full story to deliver fast, personalized support.",
            image: key01,
        },
        Key_Feature_02: {
            title: "Automate claims processing",
            text: "Reduce manual work and speed up claim resolutions with automated workflows and AI-driven document processing.",
            altDescription: "Reduce manual work and speed up claim resolutions with automated workflows and AI-driven document processing.",
            image: key02,
        },
        Key_Feature_03: {
            title: 'Enable open insurance ecosystem',
            text: 
            "Securely share APIs and data with partners, brokers, and third-party providers to expand distribution and service offerings.",
            altDescription: 'Securely share APIs and data with partners, brokers, and third-party providers to expand distribution and service offerings.',
            image: key03,
        },
        Key_Feature_04: {
            title: 'Accelerate digital projects',
            text: 
            "Use pre-built API templates, connectors, and automation tools to reduce development time and increase time-to-market.",
            altDescription: 'Use pre-built API templates, connectors, and automation tools to reduce development time and increase time-to-market.',
            image: key04,
        },
        Key_Feature_05: {
            title: 'Modernize legacy systems',
            text: 
            "Integrate older platforms with new digital services without costly replacements or downtime.",
            altDescription: 'Integrate older platforms with new digital services without costly replacements or downtime.',
            image: key05,
        },
    }
    
    return (
        <>
            <FlNav></FlNav>
            <div id="pricing"
            className="fl-cloud-product bg-black text-white"
            style={{ backgroundImage: `url(${fondo})` }}
            >
                {/* Hero Section */}
                <section id="heroProduct" className="text-center py-5">
    
                    <h1 className="fl-title-big m-0">AVAP for Insurance</h1>
                    <p className="fl-title m-0 gradient-text">Accelerate digital transformation and <br /> elevate the policyholder experience  </p>
                                                   
                </section>

               

                {/* Subtítulo descripción */}
                <section className="text-center pb-5">
                    {/*<img
                        src={dashboard}
                        className="img-fluid mt-4"
                        style={{ width: '70%', maxWidth: '800px', height: 'auto' }}
                    />*/}
                     <p className="fl-text fl-txt-container-s pt-8" >
                                AVAP Framework empowers insurance companies to innovate faster and deliver seamless, connected experiences through API-driven integration and automation. Unlock new capabilities with a unified platform that connects core systems, partners, and customers, all securely and at scale.
                                </p>
                </section>

                <div className="container text-center fl-card-border p-5">
                    <h2 className="fl-title m-0 gradient-text fl-title m-4">Why AVAP for Insurance?</h2>
                    <p className="fl-text text-center fl-txt-container-s">
                    {/* Sección Bullets */}
                    <ul className="fl-bullets fl-text text-center .fl-txt-container-s">
                        <li className="fl-bullets">Speed up new product launches with reusable APIs and low-code automation.</li>
                        <li className="fl-bullets">Modernize claims and policy management with intelligent workflows and straight-through processing.</li>
                        <li className="fl-bullets">Enhance policyholder 360 views for personalized service and real-time insights.</li>
                        <li className="fl-bullets">Embrace open insurance ecosystems by securely exposing products and data to partners.</li>
                        <li className="fl-bullets">Streamline carrier distribution with omnichannel engagement and automated processes.</li> </ul>
                    </p>
                    {/*Boton Contact Us*/}  
                    <a className="glowBtn-dark " style={{zIndex: 2}} href="/contact" target='_blank'><span className="btnInner">   Contact Us  </span></a> 
                </div>

                <br />
                     &nbsp;
                     <br />
                     &nbsp;
                     
                {/* Sección Key Features */}
                <div className="fl-wrapper">
                    <img src={gradientServices} className="gradient gradientServices" alt="" />
                    <img src={gradientApi} alt="" className="gradient gradientlife" />
                    <p className="fl-title m-0">Key capabilities</p>
                    <div className="fl-container">
                        <section id="products">
                            {/*   <h3 className="fl-title text-center">Our Products & Services</h3> */}

                            <div className="fl-productsWrapper">
                                {Object.keys(productDetailsA).map((productKey, index) => (
                                    <div key={productKey} className="fl-product-item">
                                        <div className={`row align-items-center ${index % 2 === 0 ? '' : 'flex-row-reverse'}`}>
                                            <div className="col-md-6">
                                                <div className="product-content">
                                                    <h3 className="fl-subtitle">
                                                        {productDetailsA[productKey].title}
                                                    </h3>
                                                    <p className="fl-text">
                                                        {productDetailsA[productKey].text}
                                                    </p>
                                                    
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <img
                                                    src={productDetailsA[productKey].image}
                                                    alt={productDetailsA[productKey].altDescription}
                                                    className="img-fluid product-preview"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </section>
                    </div>
                </div>

                {/* Sección Key Benefits */}   
               {/*
                <section className="container fl-z-index-2 position-relative mb-8">
                    <div className="row">
                        <div className="col  mb-5">
                            <div className="fl-title text-center mb-3">
                                Key Benefits
                            </div>
                        </div>
                    </div>
                    <div className="row ">
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
            
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                
                                <p className="fl-subtitle-xs">
                                    Speed without technical debt
                                </p>
                                <p className="fl-text">
                                Build reusable, scalable automation that integrates and adapts without starting from scratch.

                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                    
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                <p className="fl-subtitle-xs">
                                     Boost productivity across teams
                                </p>
                                <p className="fl-text">
                                    Free your people from repetitive tasks and help AI agents act with accuracy.
                                    <br />&nbsp;
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                <p className="fl-subtitle-xs">
                                    Deliver better outcomes, faster
                                </p>
                                <p className="fl-text">
                                    Surface the right data at the right time — every time.

                                </p>
                            </div>
                        </div>
                    </div>
                </section>*/} 

                {/* Sección built for secure */} 
                <section className="container">
                    <div className="row">
                        <div className="col">
                            <div className="blobContainer mb-8 mt-4">

                                <div className="blob"></div>
    

                                <div className="text-center">
                                    <h3 className='fl-title'>Ready to transform your insurance business?</h3>
                                    <p>Contact us to learn how AVAP can help your organization innovate faster, reduce costs, and deliver outstanding customer experiences.
                                    {/*Boton Contact Us*/}  
                                    <a className="glowBtn-dark " 
                                    style={{ zIndex: 2 }} 
                                    href="/contact" 
                                    target='_blank'><span className="btnInner">   Contact Us  </span></a> 
                                    </p>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </div>
            <FlFooter></FlFooter>
        </>
    );
};

export default Insurance;
